import Page from "webPage/Page";
import Gallery from "../Gallery";
import $ from "jquery";
import Track from "../Track";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";

let latest_news_track;

Page.register('page-template-index', () => {

    let hero_slider = new Gallery($('.js-hero-gallery'), {
        itemClass: "hero-gallery__slide",
        pipClass: "tabs__tab",
        navigateClass: "js-navigate",
        itemActiveModifier: "active",
        animationDuration: 900,
    });

    hero_slider.on("transitionStart", ({from, to, direction}) => {

        hero_slider.$gallery.find('.js-images .hero__img').eq(to).addClass('hero__img--in');
    }).on("transitionEnd", ({from, to, direction}) => {
        hero_slider.$gallery.find('.js-images .hero__img').eq(from).removeClass('hero__img--in hero__img--active');
        hero_slider.$gallery.find('.js-images .hero__img').eq(to).removeClass('hero__img--in').addClass('hero__img--active');
    });

    latest_news_track = new Track($('.js-track-wrap'), {
        classes: {
            block: "latest-news",
        },
    });

    $(window).on('resize', () => {
        handleLatestNewsTrack();
    });

    handleLatestNewsTrack();

    registerParallaxScenes();
});

function handleLatestNewsTrack() {
    if ($(window).outerWidth() <= 759) {
        latest_news_track.enable();
    } else {
        latest_news_track.disable();
    }
}

function registerParallaxScenes() {
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-sectors',
    //     duration: "250%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-sectors-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-sectors-text', 1, {yPercent: -20}, {yPercent: 10}),
    // ])));

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-sectors',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-sectors-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-sectors-circle', 1, {yPercent: -50}, {yPercent: 5}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-about',
    //     duration: "400%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-about-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-about-text', 1, {yPercent: 10}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-gallery',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-gallery-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-gallery-circle', 1, {yPercent: 20}, {yPercent: 10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-news',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-news-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-news-text', 1, {yPercent: 5}, {yPercent: -15}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-products',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-products-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-products-circle', 1, {yPercent: 10}, {yPercent: -20}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-news',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-news-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-news-circle', 1, {yPercent: 10}, {yPercent: -20}),
    // ])));
}

